import { HpClientStandardInputTextAndStyle } from '../../../types';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { StandardFormGroupWidget } from '../../widgets/standardFormGroupWidget';
import { BasicDropDownListControl } from '../common/basicDropDownListControl';

export function DropDownListControl({
  answers,
  answerSource,
  data,
  dataType,
  disabled,
  errors,
  formatType,
  id,
  name,
  onChange,
  onClick,
  productId,
  question,
  questionText,
  subtext,
  ui,
  value
}: HpInputControlProps): JSX.Element {
  const textAndStyle = data.textAndStyle[formatType] as HpClientStandardInputTextAndStyle;
  const error = errors ? errors[id] : undefined;
  const { placeholder, sortItemsBy } = textAndStyle;
  const control = (
    <BasicDropDownListControl
      answers={answers}
      disabled={disabled}
      eventDetail={{ type: 'standard', question }}
      id={id}
      lookup={data.lookup}
      name={name}
      onClick={onClick}
      placeholder={placeholder}
      productId={productId}
      sortItemsBy={sortItemsBy}
      ui={ui}
      value={value as string}
    />
  );

  return (
    <StandardFormGroupWidget
      answerSource={answerSource}
      control={control}
      controlType="dropdown"
      dataType={dataType}
      error={error}
      helpInfo={data.helpInfo}
      helpInfoUI={ui.helpInfo}
      id={id}
      onClick={onChange}
      question={question}
      questionText={questionText}
      subtext={subtext}
      textAndStyle={textAndStyle}
    />
  );
}
